import { useApi } from '@mainstage/core-plugin-api';
import { configurationApiRef } from '@agilelab/plugin-wb-configuration-common';
import { useQuery } from '@tanstack/react-query';

export const QUERY_KEY_WITTY_ASSISTANT_ENABLED = 'wittyAssistantEnabled';

const WITTY_NAMESPACE = 'witty';
const WITTY_ASSISTANT_ENABLED_KEY = 'assistant.enabled';
const WITTY_ASSISTANT_ENABLED_STALE_TIME_MS = 5 * 60 * 1000;

export const useWittyAssistantEnabled = (): {
  enabled: boolean;
  loading: boolean;
} => {
  const configurationApi = useApi(configurationApiRef);

  const { data, isLoading } = useQuery({
    queryKey: [QUERY_KEY_WITTY_ASSISTANT_ENABLED],
    queryFn: async () => {
      const value = await configurationApi.get<boolean>({
        namespace: WITTY_NAMESPACE,
        key: WITTY_ASSISTANT_ENABLED_KEY,
      });
      return Boolean(value);
    },
    staleTime: WITTY_ASSISTANT_ENABLED_STALE_TIME_MS,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return { enabled: data ?? false, loading: isLoading };
};
